var cov_2j4bhgus5j = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Switch/Switch.ts",
      hash = "1989e7be96f8d22c4ab3f3b92f41618c3d8a2985",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Switch/Switch.ts",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import checkItem from '../Checkbox/CheckItem';
export default checkItem('switch');